import { CommandCenterSecurityRight, EntityQueue, EntityViewVisibility } from '@jms/model';

export type QueueRightsPredicate = (right: number) => boolean;

// Mirrors the API rules in entity.queue.permissions.ts: creating implies sharing, and
// Manage Shared only reaches other people's Shared queues, never their private ones.
export function canCreateQueue(hasRight: QueueRightsPredicate): boolean {

  return hasRight(CommandCenterSecurityRight.CanCreatePersonalQueues);
}

export function isQueueOwner(queue: Partial<EntityQueue>, currentUserId: string | undefined): boolean {

  return !!queue.createdBy && !!currentUserId && queue.createdBy === currentUserId;
}

// The rights add, never subtract (WBS-11867): Manage Shared reaches every shared queue, the manager's own included.
export function canEditQueue(queue: Partial<EntityQueue>, currentUserId: string | undefined, hasRight: QueueRightsPredicate): boolean {

  if (isQueueOwner(queue, currentUserId) && hasRight(CommandCenterSecurityRight.CanCreatePersonalQueues)) return true;
  return queue.visibility === EntityViewVisibility.Shared && hasRight(CommandCenterSecurityRight.CanManageSharedQueues);
}

// Private belongs to an owner who can create. A manager is never offered it on someone else's queue (it would hand them a
// queue they never asked for), nor on their own without Create (the next save would lock them out). The API rejects both.
export function allowedQueueVisibilities(isEdit: boolean, isOwner: boolean, hasRight: QueueRightsPredicate): EntityViewVisibility[] {

  const canMakePrivate = !isEdit || (isOwner && hasRight(CommandCenterSecurityRight.CanCreatePersonalQueues));
  return canMakePrivate ? [EntityViewVisibility.Private, EntityViewVisibility.Shared] : [EntityViewVisibility.Shared];
}
